import React from "react";
import Header from "../Header/Header";
import OpreationManagmentMain from "./OpreationManagmentMain";

const OperationManagmentBody = () => {
    return (
        <div>
            <Header title="Operation Managment" />
            <OpreationManagmentMain />
        </div>
    );
};

export default OperationManagmentBody;
